import { LIST_RULE_TABLES, LIST_RULE_TABLES_SUCCESS, LIST_RULE_TABLES_ERROR, LIST_RULE_TABLES_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ListSurgeRuleTables = (state = initialState, action) => {
  switch (action.type) {
    case LIST_RULE_TABLES:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case LIST_RULE_TABLES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case LIST_RULE_TABLES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case LIST_RULE_TABLES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ListSurgeRuleTables;
